<template>
    <div ref="scrollableRef" class="pt-4 mt-3 scrollable position-relative">
        <div class="d-flex flex-column gap-3 text-center mb-3">
            <h3 class="fw-semi-bold m-0">Terms of Service</h3>
            <p class="text-secondary m-0">Last updated on June 25 2024</p>
        </div>

        <div class="d-flex flex-column gap-3 mb-4">
            <p class="m-0">
                <i class="bi bi-person-raised-hand ps-0"></i>
                <span class="fw-medium">Hello,</span>
            </p>
            <p class="m-0">
                Before you can XXX, Please read and accept our terms and conditions
            </p>
        </div>

        <div class="d-flex flex-column gap-5">
            <div v-for="(heading, index) in headings" :key="index">
                <h4>{{ index + 1 }}. {{ heading }}</h4>
                <p class="text-muted m-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus efficitur venenatis purus accumsan
                    scelerisque. Maecenas id ante elementum nisi pretium maximus. In nibh ante, ornare malesuada diam
                    quis, commodo sollicitudin lectus. Maecenas nec pharetra diam. Etiam congue ornare diam, eu
                    scelerisque orci tincidunt interdum. Nullam sit amet enim ut lectus mollis dapibus. Morbi lobortis
                    feugiat tortor, sit amet hendrerit arcu egestas at. Etiam erat ante, porta nec fringilla a,
                    efficitur sed augue. Praesent at ultricies eros.
                </p>
            </div>
        </div>

        <i ref="scrollArrowRef" class="bi bi-arrow-down-short scrollArrow"></i>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';

const headings = ['User Agreement', 'Privacy', 'Proprietary Rights']
const emit = defineEmits(['page-viewed']);
const scrollableRef = ref(null);
const scrollArrowRef = ref(null);

const checkScroll = () => {
    const element = scrollableRef.value;
    if (element) {
        const bottomReached = element.scrollTop + element.clientHeight >= element.scrollHeight - 5;
        if (bottomReached) {
            scrollArrowRef.value.classList.add('hidden')
            emit('page-viewed', true);
        } else {
            scrollArrowRef.value.classList.remove('hidden')
            emit('page-viewed', false);
        }
    }
};

onMounted(() => {
    if (scrollableRef.value) {
        scrollableRef.value.addEventListener('scroll', checkScroll);
    }
});

onUnmounted(() => {
    if (scrollableRef.value) {
        scrollableRef.value.removeEventListener('scroll', checkScroll);
    }
});
</script>

<style scoped lang="scss">
.scrollable {
    height: calc(100dvh - 200px);
    max-height: calc(100dvh - 200px);
    overflow-y: scroll;
}

@media (max-width: 991px) {
    .scrollable {
        height: calc(100dvh - 176px);
        max-height: calc(100dvh - 176px);
        overflow-y: scroll;
    }
}

@media (max-width: 767px) {
    .scrollable {
        height: calc(100dvh - 160px);
        max-height: calc(100dvh - 160px);
        overflow-y: scroll;
    }
}

@keyframes wobble {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-5px);
    }
}

.scrollArrow {
    position: sticky;
    bottom: 0.5em;
    left: calc(50% - 24px);
    border-radius: 50%;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    animation: wobble 1.2s infinite ease-in-out;
}
</style>